import { jsxs as c, Fragment as f, jsx as o } from "react/jsx-runtime";
import "react";
import { ChoicesList as p } from "../ChoicesList/ChoicesList.js";
import { C as e } from "../../ChoicesItem-CGIr6Qga.mjs";
function b({ list: u, initialItem: s = null, handleOnClick: d }) {
  return /* @__PURE__ */ c(f, { children: [
    s && (s == null ? void 0 : s.status) !== "filtered" && /* @__PURE__ */ o(e, { item: s, handleOnClick: d, disabled: (s == null ? void 0 : s.status) === "selected" }, s.id),
    /* @__PURE__ */ o(p, { children: u.map((r) => r.subcategories.length ? /* @__PURE__ */ o(b, { list: r.subcategories, initialItem: r, handleOnClick: d }, `list-${r.id}`) : r.status !== "filtered" ? /* @__PURE__ */ o(e, { item: r, handleOnClick: d, disabled: r.status === "selected" }, r.id) : "") })
  ] });
}
export {
  b as CreateChoiceList,
  b as default
};
